module.exports = __webpack_public_path__ + "static/media/slugman_profile.78302b5a.png";